<template>
    <header class="dashHeader">
        <img :src="imageURL" class="dashMainImg dashOffset"/>
        <div class="dashMainInfo"> 
            <div class="dashInfoPrimary">
                <h1 class="dashPrimaryTitle">{{name}}</h1>
                <div v-if="flag"><img :src="flagImg()" class="dashFlag"></div>
            </div>
            <div class="dashInfoSecondary">
                <p v-if="type" class="dashSecondaryItem"> {{type}} </p> 
                <p v-if="mmsi" class="dashSecondaryItem"> MMSI: {{mmsi}} </p> 
                <p v-if="imo" class="dashSecondaryItem"> IMO: {{imo}} </p>
            </div>
        </div>
    </header>
</template>

<script>
import axio from 'axios';

export default {
    name: "dash-header",
    data: () => ({
        name: "Vessel",
        flag: null,
        type: "",
        mmsi: 0,
        imo: 0,
        imageURL: "/logo.png"
    }),
    methods: {
        updateInfo: async function({name="Vessel", flag="", type="", mmsi=0, imo=0}) {
            var globv = this;
            globv.name = name;
            globv.type = type;
            globv.mmsi = mmsi;
            globv.imo = imo;
            globv.flag = flag;

            try {
                let response = await axio.get(`https://www.raptor1.io/images/ships/${mmsi}.jpg`);
                if (response.status < 300) {
                    globv.imageURL = `https://www.raptor1.io/images/ships/${mmsi}.jpg`;
                }
            }
            catch {
                globv.imageURL = "/logo.png";
            }
        },
        reset: function() {
            var globv = this;
            globv.name = "Vessel",
            globv.flag = null;
            globv.type = "";
            globv.mmsi = 0;
            globv.imo = 0;
            globv.imageURL = "/logo.png";
        },
        flagImg: function() {
            var globv = this;
            if (globv.flag)
                return require('../../assets/flags/svg/' + globv.flag + '.svg');
            else
                return "";
        }
    }
}
</script>

<style lang="scss" scoped>
.dashHeader {
    display: flex;
    justify-content: flex-start;
    padding: 10px;
    background-color: #2f55a4;
    color: white;
    background-color: var(--primaryColor);
    color: var(--primaryTextColor);
    margin-bottom: 5rem;
}

.dashOffset {
    margin-left: 15%;
}

.dashMainImg {
    height: 10rem; 
    background-color: white;
    margin-bottom: -5rem;
}

.dashMainInfo {
    display: flex;
    flex-direction: column;
    padding: 5px;
    margin: 0 10px;
    min-width: 237px;
}

.dashInfoPrimary {
    font-size: 1.5rem;
    display: flex;
    padding: 5px 0;
    align-items: center;
}

.dashPrimaryTitle {
    font-weight: bold;
    margin: 0 1.5rem 0 0;
}

.dashFlag {
    height: 2rem;
}

.dashInfoSecondary {
    font-size: 0.9rem;
    display: flex;
}

.dashSecondaryItem {
    margin-right: 20px;
}

@media (max-width: 1350px) {
    .dashOffset {
        margin-left: 0;
    }
}

@media (max-width: 780px) {
    .dashInfoSecondary {
        flex-direction: column;
    }

    .dashHeader {
        margin-bottom: 4rem;
    }
}

@media (max-width: 580px) {
    .dashInfoPrimary {
        flex-direction: column;
        align-items: flex-start;
    }

    .dashMainImg {
        margin-bottom: 0;
    }

    .dashHeader {
        margin-bottom: 0;
    }
}

@media (max-width: 500px) {
    .dashHeader {
        flex-direction: column;
    }

    .dashMainImg {
        margin-bottom: 5px;
        width: 100%;
        height: auto;
    }

    .dashFlag {
        height: 5rem;
    }

    .dashInfoPrimary, .dashInfoSecondary {
        align-items: center;
    }

    .dashInfoSecondary {
        font-size: 1rem;
    }
}
</style>